const LoggerMiddleWare = (store: any) => (next: any) => (action: any) => {
  let result = next(action);
  console.groupEnd();
  return result;
};

export default LoggerMiddleWare;
